// Typelizer digest 509e6238de87423fa2976bcb74be76b4
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** PATCH /bank_statement_uploads/:bank_statement_upload_id/rows/:id/mark_processed */
  markProcessed: (
    params: { bankStatementUploadId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/bank_statement_uploads/:bank_statement_upload_id/rows/:id/mark_processed', params, options),
    method: 'patch',
  }),

  /** POST /bank_statement_uploads/:bank_statement_upload_id/rows */
  create: (
    params: { bankStatementUploadId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/bank_statement_uploads/:bank_statement_upload_id/rows', params, options),
    method: 'post',
  }),

  /** PATCH /bank_statement_uploads/:bank_statement_upload_id/rows/:id */
  update: (
    params: { bankStatementUploadId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'patch'> => ({
    url: buildUrl('/bank_statement_uploads/:bank_statement_upload_id/rows/:id', params, options),
    method: 'patch',
  }),

  /** DELETE /bank_statement_uploads/:bank_statement_upload_id/rows/:id */
  destroy: (
    params: { bankStatementUploadId: string | number; id: string | number },
    options?: RouteOptions,
  ): RouteDefinition<'delete'> => ({
    url: buildUrl('/bank_statement_uploads/:bank_statement_upload_id/rows/:id', params, options),
    method: 'delete',
  }),
}
